<div class="top">
  <div class="when-expanded">
    <ng-content></ng-content>
  </div>
  <div class="when-collapsed">
    <ng-content select="[sidePanelCollapsed]"></ng-content>
  </div>
</div>
<div class="bottom">
  <ng-content select="[sidePanelBottom]"></ng-content>

  @if (collapsible() && canToggle()) {
  <div class="when-collapsed side-panel-toggle__collapsed" (click)="collapsed.set(false)">
    <i class="far fa-chevron-double-right not-4 p-relative"></i>
  </div>

  <div class="when-expanded side-panel-toggle__expanded-wrapper">
    <div class="side-panel-toggle__expanded" (click)="collapsed.set(true)">
      <i class="far fa-chevron-double-left"></i>
    </div>
  </div>
  }
</div>